import React from 'react';
import { Check, AlertTriangle, X } from 'lucide-react';

interface StoplightProps {
  status: 'green' | 'amber' | 'red' | 'neutral';
  srLabel: string;
}

export const Stoplight: React.FC<StoplightProps> = ({ status, srLabel }) => {
  const getStatusIcon = (lightStatus: string, isActive: boolean) => {
    if (!isActive) return null;
    
    switch (lightStatus) {
      case 'green':
        return <Check className="w-3 h-3 text-white" />;
      case 'amber':
        return <AlertTriangle className="w-3 h-3 text-white" />;
      case 'red':
        return <X className="w-3 h-3 text-white" />;
      default:
        return null;
    }
  };

  const getLightClasses = (lightStatus: string, isActive: boolean) => {
    const baseClasses = "w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all duration-200";
    
    if (status === 'neutral') {
      return `${baseClasses} bg-gray-400 border-gray-500`;
    }
    
    if (isActive) {
      switch (lightStatus) {
        case 'green':
          return `${baseClasses} bg-green-500 border-green-600 shadow-lg shadow-green-500/50`;
        case 'amber':
          return `${baseClasses} bg-yellow-400 border-yellow-500 shadow-lg shadow-yellow-400/50`;
        case 'red':
          return `${baseClasses} bg-red-500 border-red-600 shadow-lg shadow-red-500/50`;
        default:
          return `${baseClasses} bg-gray-300 border-gray-400`;
      }
    } else {
      return `${baseClasses} bg-gray-200 border-gray-300`;
    }
  };

  return (
    <div className="flex items-center space-x-2" role="status" aria-label={srLabel}>
      <span className="sr-only">{srLabel}</span>
      
      <div className="flex items-center space-x-1">
        <div className={getLightClasses('green', status === 'green')}>
          {getStatusIcon('green', status === 'green')}
        </div>
        <div className={getLightClasses('amber', status === 'amber')}>
          {getStatusIcon('amber', status === 'amber')}
        </div>
        <div className={getLightClasses('red', status === 'red')}>
          {getStatusIcon('red', status === 'red')}
        </div>
      </div>
    </div>
  );
};
